import { Image, Stack, Text, Title } from "@mantine/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { imgEtiprint, imgLogoCt } from "../shared/images";
import { NavBarContainer } from "./NavBarContainer";

const DISTRIBUTORS = [
  {
    name: "Etiprint",
    img: imgEtiprint,
    address: "Etiprint, Arturo B de la garza #115 Monterrey",
    email: "laurag@etiprint.com",
    phone: "+52 81 8478 0995",
  },
  {
    name: "Grupo Empresarial CT",
    img: imgLogoCt,
    address: "Grupo Empresarial CT, Joaquin García #256 Monterrey",
    email: "jorgeaguirre@ctetiquetas.com",
    phone: "+52 81 1158 6565",
  },
];

export function ViewDistributorsPage() {
  const { t } = useTranslation();

  return (
    <NavBarContainer variant="marketing" title={t("distributors.title")}>
      <Stack gap="xl">
        {DISTRIBUTORS.map((d) => (
          <Stack key={d.name} align="center" gap="xs">
            <Image src={d.img} alt={d.name} maw={200} />
            <Title order={4}>{d.name}</Title>
            <Text ta="center">{d.address}</Text>
            <Text>
              <a href={`mailto:${d.email}`}>{d.email}</a>
            </Text>
            <Text>{d.phone}</Text>
          </Stack>
        ))}
      </Stack>
    </NavBarContainer>
  );
}
